import React from 'react';
import { useTranslation } from 'react-i18next';

import { Box } from '@mui/material';

import theme from '../../../styles/theme';
import AppButton from '../app-button/AppButton';
import { useStyles } from './AppBarWithActionButtons.styles';

interface IAppBarWithActionButtonsProps {
  editLabel?: string;
  deleteLabel?: string;
  onEditClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
  onDeleteClick?: (e: React.MouseEvent<HTMLInputElement>) => void;
}

export function AppBarWithActionButtons(props: IAppBarWithActionButtonsProps) {
  const { classes } = useStyles(theme);
  const { t } = useTranslation();
  const {
    editLabel = t('common.edit'),
    deleteLabel = t('common.delete'),
    onEditClick,
    onDeleteClick,
  } = props;

  return (
    <Box className={classes.buttonsWrapper}>
      {onEditClick && <AppButton onClick={onEditClick}>{editLabel}</AppButton>}
      {onDeleteClick && (
        <AppButton color="error" onClick={onDeleteClick}>
          {deleteLabel}
        </AppButton>
      )}
    </Box>
  );
}
